import BHYT from "./BHYT"
export default BHYT